import { InjectionToken, Injector, NgZone, runInInjectionContext, Type } from '@angular/core'
import { logger } from '../util/log.util.js'

class DIService {
  injector!: Injector
  ngZone!: NgZone

  /**
   * Must be called as early as possible to make DI work
   */
  init(injector: Injector): void {
    this.injector = injector
    this.ngZone = injector.get(NgZone)
  }

  get<T = any>(token: Type<T> | InjectionToken<T>): T {
    if (!this.injector) {
      // This warning is to help debugging di issues
      logger.warn('di.get() is called before di.init()!')
      return undefined as any
    }

    return this.injector.get(token)
  }

  runInInjectionContext<T = any>(token: Type<T>): T {
    if (!this.injector) {
      // This warning is to help debugging di issues
      logger.warn('di.runInInjectionContext() is called before di.init()!')
      return undefined as any
    }

    return runInInjectionContext(this.injector, () => new token())
  }
}

export const di = new DIService()

export function runOutsideAngular<T>(fn: (...args: any[]) => T): T {
  return di.ngZone.runOutsideAngular(fn)
}
